<template>
  <div
    id="from-the-founders"
    class="products-founders"
  >
    <ProductsFoundersContainer
      :product-url="parseUrl"
      :posts="founders.posts"
      :links="founders.links"
      :is-select="isSelect"
    />
  </div>
</template>

<script>
import ProductsFoundersContainer from './ProductsFoundersContainer.vue';

export default {
  components: {
    ProductsFoundersContainer,
  },
  props: {
    productUrl: {
      type: String,
      default: '',
    },
    isSelect: {
      type: Boolean,
    },
    founders: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    parseUrl() {
      if (!this.productUrl) return null;

      return {
        label: this.productUrl.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0],
        value: this.productUrl,
      };
    },
  },
};
</script>

<style lang="scss">
  @import '~/styles/dorado/main';

  // TODO -- Remove once styles below are standard
  .products-founders {
    h1,
    h2,
    h3,
    h4,
    h5 {
      font-family: $headings-font-family;
    }

    p,
    a,
    span {
      font-weight: $font-weight-normal;
      font-size: $font-size-base;
      font-family: $font-family-base;
    }

    a {
      color: $bolt;
      transition: 150ms color;

      &:hover {
        color: $deep-ocean;
      }
    }
  }

</style>
